import React, { useState, useEffect } from "react";
import {
  Popover,
  Button,
  Checkbox,
  FormControlLabel,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { subDays } from 'date-fns';
import { getfilterdata, getfilterdatabrands } from "./api";
import { getToken } from "../../utils/utils";
import { isTemplateExpression } from "typescript";
import calendar from "../../../src/assests/images/calendar.svg";
import arrowLeft from "../../../src/assests/images/arrow-left.svg";
import arrowRight from "../../../src/assests/images/arrow-right.png";
import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";
import DatePicker from "react-datepicker";
import { useLocation } from "react-router-dom";

interface FilterOption {
  label: string;
  value: string;
  id?: string;
}

interface FilterCategory {
  category: string;
  options: FilterOption[];
}

interface FilterPopoverProps {
  anchorEl: HTMLElement | null;
  filterData1: Array<FilterCategory>;
  onClose: () => void;
  onApply: (filters: SelectedFilters) => void;
  tags: string[];
  startDate1?: string | null;
  endDate1?: string | null;
  setTags: React.Dispatch<React.SetStateAction<string[]>>;
  appliedFilters: Record<string, string[]>;
  selectedRange: string;
  setSelectedRange: (range: string) => void;
  selectedTab: number;
  setSelectedTab: (tabIndex: number) => void;
  applydetailes: boolean;
  setapply: (value: boolean) => void;
}

type SelectedFilters = Record<string, { value: string; id: string | null }[]>;

const FilterPopover: React.FC<FilterPopoverProps> = ({
  anchorEl,
  filterData1,
  applydetailes,
  setapply,
  selectedTab,
  setSelectedTab,
  onClose,
  onApply,
  tags,
  setTags,
  appliedFilters,
  startDate1,
  endDate1,
  selectedRange, setSelectedRange,
}) => {


  const [selectedFilters, setSelectedFilters] = useState<SelectedFilters>({});
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  // const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedFilters1, setSelectedFilters1] = useState<SelectedFilters>({});
  const [filterData, setFilters] = useState<Array<FilterCategory>>([]);
  const [options, setOptions] = useState<FilterOption[]>([]);
  const [loading, setLoading] = useState(false);
  const token = getToken();
  const location = useLocation();
  // Fetch filter data on tab change
  console.log(location.pathname, "locationssssssssssss")
  // Update options when filterData updates
  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      if (filterData.length > 0) {
        setOptions(filterData[selectedTab]?.options || []);
      } else {
        setOptions([]);
      }
      setLoading(false);
    };
    fetchOptions();
  }, [filterData, selectedTab]);
  // Fetch options based on selected filters

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    setOptions([]);
  };
  const [locations22, setLocations22] = useState("");

  const [tasktype22, settasktype22] = useState("");
  const [taskids, settaskids] = useState("");
  const [taskstatus, settaskstatus] = useState("");
  useEffect(() => {
    if (location.pathname === "/reports/taskreports") {
      getfilterdata(
        token,
        locations22 ? locations22 : "",
        tasktype22 ? tasktype22 : "",
        taskids ? taskids : "",
        taskstatus ? taskstatus : "",
        startDate1 ? startDate1 : "",
        endDate1 ? endDate1 : ""
      ).then((res) => {
        if (res.status) {
          console.log(res.data.data, "resdata");
          setFilters(res?.data?.data || []);
        }
      });
    }
  }, [
    token,
    locations22,
    tasktype22,
    taskids,
    taskstatus,
    selectedTab,
    startDate1 && endDate1,
  ]);



  useEffect(() => {
    if (location.pathname === "/brands") {
      getfilterdatabrands(token).then((res) => {
        if (res.status) {
          console.log(res.data.data, "resdata");
          setFilters(res?.data?.data || []);
        }
      });
    }
  }, [token]);



  console.log(selectedTab, "selectedTabsssssssssssssssssss")
  const handleCheckboxChange = (
    category: string,
    value: string,
    id?: string | null
  ) => {
    console.log(category, "categoryssssssssss");
    setSelectedFilters((prev) => {
      const categoryFilters = prev[category] || [];
      console.log(categoryFilters, "5555555555577777");
      const alreadyExists = categoryFilters.some((item) =>
        id ? item.id === id : item.value === value
      );

      if (alreadyExists) {
        // Remove existing filter entry
        return {
          ...prev,
          [category]: categoryFilters.filter((item) =>
            id ? item.id !== id : item.value !== value
          ),
        };
      } else {
        // Add new filter entry (preserve `id`)
        return {
          ...prev,
          [category]: [...categoryFilters, { value, id: id ?? null }],
        };
      }
    });
    setSelectedFilters1(selectedFilters);
  };

  const handleDateSelect = (label: string) => {
    let date = new Date();
    switch (label) {
      case "Today":
        break;
      case "Last2Days":
        date.setDate(date.getDate() - 2);
        break;
      case "Last3Days":
        date.setDate(date.getDate() - 3);
        break;
      case "Last1Week":
        date.setDate(date.getDate() - 7);
        break;
      case "MoreThan15Days":
        date.setDate(date.getDate() - 16);
        break;
    }

    setSelectedDate(date);

    setSelectedRange(label); // Update selected button

  };

  console.log(selectedRange, "selectedRangefffffffffff")
  const handleSelectAll = (category: string) => {
    setSelectedFilters((prev) => {
      const allSelected = (prev[category] || []).length === options.length;
      return {
        ...prev,
        [category]: allSelected
          ? []
          : options.map((option) => ({
            value: option.value,
            id: option.id ?? null,
          })),
      };
    });
  };

  console.log(selectedFilters, "selectedFiltersssssssssssss");
  const handleApply = () => {

    console.log(selectedFilters, "appliappliappliappli");
    const updatedFilters = Object.fromEntries(
      Object.entries(selectedFilters).map(([category, values]) => [
        category,
        values.map((item) => ({
          value: item.value,
          id: item.id ?? null, // Preserve ID properly
        })),
      ])
    );

    console.log(
      "Before Applying - Selected Filters:",
      JSON.stringify(selectedFilters, null, 2)
    );
    console.log("Applying Filters:", JSON.stringify(updatedFilters, null, 2));
    setapply(true)
    setSelectedFilters(updatedFilters);
    onApply(updatedFilters);

    onClose();
    setTimeout(() => {
      setapply(false); // Run after 1 second
    }, 1000);
    // setapply(false)
  };
  console.log(applydetailes, "applydetailes")

  useEffect(() => {
    if (selectedFilters.Location) {
      setLocations22(
        selectedFilters.Location.map((item) => item.value).join(", ")
      );
    }
    if (selectedFilters.TaskType) {
      settasktype22(
        selectedFilters.TaskType.map((item) => item.value).join(", ")
      );
    }
    if (selectedFilters.Tasks) {
      settaskids(selectedFilters.Tasks.map((item) => item.id).join(", "));
    }
    if (selectedFilters.Status) {
      settaskstatus(
        selectedFilters.Status.map((item) => item.value).join(", ")
      );
    }
  }, [selectedFilters]); // ✅ Dependency array should be separate

  console.log(locations22, "locations22ssssssssssssssss");
  const handleClearAll = () => {
    setSelectedFilters({});
  };
  console.log(options, "optionssssssssssssss");
  console.log(filterData, "filterDatafilterDatafilterData");
  console.log(selectedTab, "selectedTabsssssssssssssss")
  return filterData.length > 0 ? (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      PaperProps={{
        sx: {
          borderRadius: "10px", // Rounded corners
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", // Optional: soft shadow
          overflow: "hidden", // Optional: cleaner corners
        },
      }}
    >
      <Box className="report__task" sx={{ display: "flex", padding: "20px 0", textAlign: "left !important" }}>
        {/* Sidebar Tabs */}
        <Tabs
          className="r"
          orientation="vertical"
          value={selectedTab}
          onChange={handleTabChange}
          sx={{ borderRight: 1, borderColor: "divider", textAlign: "left !important" }}
        >
          {filterData.map((filter) => (
            <Tab sx={{
              alignItems: "flex-start",
              fontWeight: "400 !important",
              backgroundColor: "transparent",
              color: "#000 !important",
              width: "200px",

              "&.Mui-selected": {
                backgroundColor: "#EEF4FF",
                color: "#000 !important",
                fontWeight: "bold",
              },
              "&:hover": {
                backgroundColor: "#EEF4FF",
                color: "#000 !important",
              },
            }} key={filter.category} label={filter.category} />
          ))}
        </Tabs>

        {/* Main Content Area */}
        {filterData[selectedTab]?.category === "LastLogin" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "start" }}>

            {["Today", "Last2Days", "Last3Days", "Last1Week", "MoreThan15Days"].map((label) => (
              <Button
                key={label}
                onClick={() => handleDateSelect(label)}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  fontWeight: "400",
                  width: "100%",
                  justifyContent: "start",
                  borderRadius: "0",
                  color: selectedRange === label ? "black !important" : "black !important",
                  backgroundColor: selectedRange === label ? "#EEF4FF !important" : "transparent !important",
                  // backgroundColor: selectedRange === label ? "#EEF4FF !important" : "transparent !important",
                }}
              >
                {label}
              </Button>
            ))}

          </Box>
        )}

        <Box
          className="yyyyyyyyyyy"
          sx={{
            px: 2,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            height: "285px",
            overflowY: "scroll",
            // overflowX: "scroll",
            width: "290px",
          }}
        >
          {/* Conditional DatePicker for 'LastLogin' */}
          {filterData[selectedTab]?.category === "LastLogin" && (
            <Box className="pppppppppp">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                  console.log(date, "Selected Date");
                }}
                inline
                calendarClassName="static-datepicker"
                dayClassName={(date) =>
                  selectedDate &&
                    date.toDateString() === selectedDate.toDateString()
                    ? "selected-date"
                    : ""
                }
                renderCustomHeader={({
                  date,
                  decreaseMonth,
                  increaseMonth,
                  decreaseYear,
                  increaseYear,
                }) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 8,
                    }}
                  >
                    <button onClick={decreaseYear}>
                      <img src={doubleArrowLeft} alt="double left arrow" />
                    </button>
                    <button onClick={decreaseMonth}>
                      <img src={arrowLeft} alt="left arrow" />
                    </button>
                    <span style={{ margin: "0 10px" }}>
                      {date.toLocaleString("default", {
                        year: "numeric",
                        month: "long",
                      })}
                    </span>
                    <button onClick={increaseMonth}>
                      <img src={arrowRight} alt="right arrow" />
                    </button>
                    <button onClick={increaseYear}>
                      <img src={doubleArrowRight} alt="double right arrow" />
                    </button>
                  </div>
                )}
              />
            </Box>
          )}

          {/* Filter Options */}
          {loading ? (
            <p>Loading options...</p>
          ) : (
            <>
              {/* Select All */}
              {options.length > 0 && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        (
                          selectedFilters[filterData[selectedTab]?.category] ||
                          []
                        ).length === options.length
                      }
                      indeterminate={
                        (
                          selectedFilters[filterData[selectedTab]?.category] ||
                          []
                        ).length > 0 &&
                        (
                          selectedFilters[filterData[selectedTab]?.category] ||
                          []
                        ).length < options.length
                      }
                      onChange={() =>
                        handleSelectAll(filterData[selectedTab]?.category)
                      }

                    />
                  }
                  label="Select All"
                />
              )}

              {/* Individual Options */}
              {options.map((option) => (
                <FormControlLabel
                  key={option.id ?? option.value}
                  control={
                    <Checkbox
                      checked={(
                        selectedFilters[filterData[selectedTab]?.category] || []
                      ).some((item) => {
                        const isChecked = item.id
                          ? item.id === option.id
                          : item.value === option.value;
                        return isChecked;
                      })}
                      onChange={() =>
                        handleCheckboxChange(
                          filterData[selectedTab]?.category,
                          option.value,
                          option.id
                        )
                      }
                    />
                  }
                  label={
                    option.label !== null && option.label !== undefined
                      ? String(option.label)
                      : "Unknown"
                  }
                />
              ))}
            </>
          )}
        </Box>
      </Box>

      {/* Footer Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          p: 2,
        }}
      >
        <Button
          onClick={handleClearAll}
          sx={{
            border: "1px solid #ddd",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#282829",
            marginRight: "16px !important",
            textTransform: "capitalize",
          }}
        >
          Clear All
        </Button>
        <Button
          sx={{
            border: "1px solid #C8172F",
            borderRadius: "8px",
            background: "transparent",
            fontSize: "14px",
            fontWeight: "500",
            textTransform: "capitalize",
            color: "#C8172F",
            boxShadow: "unset",
          }}
          variant="contained"
          color="error"
          onClick={handleApply}
        >
          Apply
        </Button>
      </Box>
    </Popover>
  ) : null;
};

export default FilterPopover;
